import styled from '@emotion/styled'
import tokens from '@lacedltd/design-tokens'
import { mediaQuery } from '@lacedltd/laced-components'
import { ChipProps } from './Chip.types'

const primary = {
  borderColor: tokens.color.airJordan.p,
  borderWidth: tokens.borderWidth.s
}

const secondary = {
  borderColor: tokens.color.airJordan[300],
  borderWidth: tokens.borderWidth.xs,
  '&:focus-visible': {
    outlineOffset: `calc(-1 * ${tokens.borderWidth.m})`
  }
}

export const Container = styled.a<ChipProps>(
  {
    height: '2.5rem',
    padding: `${tokens.spacing[3]} ${tokens.spacing[6]}`,
    backgroundColor: tokens.color.yeezy[0],
    borderRadius: '5rem',
    borderStyle: 'solid',
    color: tokens.color.airJordan.p,
    fontFamily: tokens.fontFamilies.primary,
    fontSize: tokens.fontSize[1],
    lineHeight: tokens.lineHeight.body,
    textTransform: 'none',
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',

    [mediaQuery.m.min]: {
      '&:hover': {
        boxShadow: '0 0.125rem 0.625rem rgba(20, 21, 22, 0.2)'
      }
    },

    '&:active': {
      boxShadow: '0 0.125rem 0.625rem rgba(20, 21, 22, 0.2)'
    },
    '&:focus-visible': {
      borderColor: 'transparent',
      outline: `${tokens.borderWidth.m} solid ${tokens.color.foamRunner[300]}`,
      borderRadius: '5rem'
    }
  },
  ({ type }) => (type === 'primary' ? primary : secondary)
)
